import { useSelector } from "react-redux";
import {
  selectIsWarehouse,
  selectIsPlant,
  selectCanSwitchModules,
} from "../../store/slices/moduleSlice";
import ModuleTabs from "../../components/ModuleTabs";
import YardReport from "./YardReport";
import WarehouseReport from "./WarehouseReport";
import PlantReport from "./PlantReport";

const Report = () => {
  const isWarehouse = useSelector(selectIsWarehouse);
  const isPlant = useSelector(selectIsPlant);
  const canSwitchModules = useSelector(selectCanSwitchModules);

  const renderReport = () => {
    if (isPlant) return <PlantReport />;
    if (isWarehouse) return <WarehouseReport />;
    return <YardReport />;
  };

  return (
    <div className="flex w-full h-screen overflow-y-scroll bg-gray-200">
      <div className="flex-1 p-8">
        {canSwitchModules && (
          <div className="mb-4">
            <ModuleTabs />
          </div>
        )}
        {renderReport()}
      </div>
    </div>
  );
};

export default Report;